import { render, staticRenderFns } from "./AskAnswerSources.vue?vue&type=template&id=074984ce&scoped=true&"
import script from "./AskAnswerSources.vue?vue&type=script&lang=js&"
export * from "./AskAnswerSources.vue?vue&type=script&lang=js&"
import style0 from "./AskAnswerSources.vue?vue&type=style&index=0&id=074984ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074984ce",
  null
  
)

export default component.exports